import { RiCheckLine } from 'react-icons/ri'

export default function StepIndicator({ steps, current }) {
  return (
    <div className="flex items-center justify-center gap-0">
      {steps.map((step, i) => {
        const done   = step.id < current
        const active = step.id === current

        return (
          <div key={step.id} className="flex items-center">
            <div className="flex flex-col items-center">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold font-body
                              transition-all duration-300 border-2 ${
                done   ? 'bg-salon-primary border-salon-primary text-white' :
                active ? 'bg-white border-salon-primary text-salon-primary shadow-salon-sm' :
                         'bg-white border-salon-cream-dark text-salon-muted'
              }`}>
                {done ? <RiCheckLine className="text-base" /> : step.id}
              </div>
              <p className={`text-xs font-body mt-1.5 hidden sm:block transition-colors duration-300 ${
                active ? 'text-salon-primary font-semibold' : done ? 'text-salon-primary/70' : 'text-salon-muted'
              }`}>
                {step.label}
              </p>
            </div>

            {/* Connector */}
            {i < steps.length - 1 && (
              <div className={`h-0.5 w-8 sm:w-14 mx-1 mb-4 transition-all duration-300 rounded-full ${
                done ? 'bg-salon-primary' : 'bg-salon-cream-dark'
              }`} />
            )}
          </div>
        )
      })}
    </div>
  )
}
